import React from "react";
import { useQuery } from "react-query";
import { Badge, DropdownItem, DropdownToggle, DropdownMenu } from "reactstrap";
import { getNotifications } from "../../hooks/notifications";

// ==============================|| GIGS ||============================== //

const Notifications = () => {
  const userId = localStorage.getItem("userId");
  const { data: notifications, isLoading } = useQuery(["notifications"], () => getNotifications({ userId }));

  if (isLoading) {
    return <div>Loading Notifications...</div>;
  }

  return (
    <>
      <DropdownToggle nav>
        <i className="icon-bell"></i>
        <Badge pill color="danger">
          {notifications.length}
        </Badge>
      </DropdownToggle>
      <DropdownMenu right>
        <DropdownItem header tag="div" className="text-center">
          <strong>You have {notifications.length} notifications</strong>
        </DropdownItem>
        {notifications.map((notification, index) => {
          return (
            <DropdownItem key={notification.notificationId}>
              <i className="icon-user-follow text-success"></i> {notification.message}
            </DropdownItem>
          );
        })}
      </DropdownMenu>
    </>
  );
};

export default Notifications;
